module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_10X_DCIS.3818044d.png";